export const GET_HISTORIES_SUCCESS = 'GET_HISTORIES_SUCCESS'
export const ADD_HISTORIES_SUCCESS = 'ADD_HISTORIES_SUCCESS'
export const UPDATE_HISTORIES_SUCCESS = 'UPDATE_HISTORIES_SUCCESS'
export const REQUEST = 'REQUEST'
export const FAILURE = 'FAILURE'
